import { UtensilsCrossed } from "lucide-react";
import "./SalarFoodCategories.css";

type FoodCategory = {
    name: string;
    image: string;
};

const foodCategories: FoodCategory[] = [
    { name: "Indian Meals", image: "/assets/images/food/max-cat-1.png" },
    { name: "South Indian", image: "/assets/images/food/max-cat-2.png" },
    { name: "Biryani", image: "/assets/images/food/max-cat-3.png" },
    { name: "Pizza", image: "/assets/images/food/max-cat-4.png" },
    { name: "Burgers", image: "/assets/images/food/max-cat-5.png" },
    { name: "Chinese", image: "/assets/images/food/max-cat-6.png" },
    { name: "Healthy Food", image: "/assets/images/food/max-cat-7.png" },
    { name: "Desserts", image: "/assets/images/food/max-cat-8.png" },
    { name: "Cakes", image: "/assets/images/food/max-cat-9.png" },
    { name: "Rolls & Wraps", image: "/assets/images/food/max-cat-10.png" },
    { name: "Sandwiches", image: "/assets/images/food/max-cat-11.png" },
    { name: "North Indian", image: "/assets/images/food/max-cat-12.png" },
    { name: "Seafood", image: "/assets/images/food/max-cat-13.png" },
    { name: "Chicken", image: "/assets/images/food/max-cat-14.png" },
    { name: "Street Food", image: "/assets/images/food/max-cat-15.png" },
    { name: "Breakfast", image: "/assets/images/food/max-cat-16.png" },
    { name: "Beverages", image: "/assets/images/food/max-cat-17.png" },
    { name: "Ice Cream", image: "/assets/images/food/max-cat-18.png" },
];

const SalarFoodCategories = () => {
    return (
        <section className="salar-food">
            <div className="salar-food-container">
                <div className="salar-food-header">
                    <div className="salar-food-heading">
                        <div className="salar-food-kicker">
                            <span className="salar-food-badge">
                                <UtensilsCrossed size={13} strokeWidth={1.9} />
                                SALAR FOOD
                            </span>
                            <span className="salar-food-delivery-text">Food Delivery</span>
                        </div>
                        <h2>What are you craving today?</h2>
                        <p>Explore popular dishes, cuisines and quick bites around you.</p>
                    </div>
                </div>
                <div className="salar-food-panel">
                    {foodCategories.map((food) => (
                        <button type="button" className="salar-food-item" key={food.image}>
                            <span className="salar-food-visual">
                                <img src={food.image} alt={food.name} />
                            </span>
                            <strong className="salar-food-name">{food.name}</strong>
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default SalarFoodCategories;